module.exports = __webpack_public_path__ + "img/customer-img2.3733daed.png";